import { render, staticRenderFns } from "./TitleBarCreateProject.vue?vue&type=template&id=52adfede"
import script from "./TitleBarCreateProject.vue?vue&type=script&lang=js"
export * from "./TitleBarCreateProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports